module.exports = __webpack_public_path__ + "static/media/play.452550be.png";